import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #27293d !important;
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;
  background-color: #27293d !important;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  background-color: #27293d !important;
`;
